import { css } from 'styled-components'

export const colors = {
  blueText: '#277AFA',
  blueLine: "#698BFC",
  pinkText: "hsl(334, 100%, 50%)",
  greyText: '#222',
  textShadow: 'hsla(334, 100%, 50%, 0.5)',
  darkBackground: 'hsl(237, 100%, 5%)',
  offWhite: '#eee',
  white: '#fefefe'
}
colors.lightOnDark = css`
  background: ${colors.darkBackground};
  color: ${colors.offWhite};
`

export const constants = {
  gridSpacing: "100px",
  gridThickness: { x: "1px", y: "5px" }
}

export const breakpoints = {
  retina: (...args) => css`
    @media (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dppx) {
      ${ css(...args) }
    }
  `,
  nonretina: (...args) => css`
    @media (-webkit-max-device-pixel-ratio: 1.249), (max-resolution: 119dppx) {
      ${ css(...args) }
    }
  `,
  phone: (...args) => css`@media (max-width: 414px) { ${ css(...args) } }`,
  handheld: (...args) => css`@media (max-width: 600px) { ${ css(...args) } }`,
}

const wreck = options => {
  class TrainCarriage {
    constructor(rules) {
      this.rules = rules
    }

    toString() {
      return this.rules.filter(v => v !== undefined && v !== null).map(v => `${v};`).join('\n')
    }
  }

  Object.keys(options).forEach(option => {
    Object.defineProperty(TrainCarriage.prototype, option, {
      get() {
        return new TrainCarriage(this.rules.concat(options[option]))
      }
    })
  })

  return new TrainCarriage([options.default])
}

export const typography = wreck({
  h1: css`font-size: 1.75rem;
    ${breakpoints.phone`
      font-size: 1.5rem;
    `}
  `,
  h2: css`font-size: 1.5rem;
    ${breakpoints.phone`
      font-size: 1.25rem;
    `}
  `,
  h3: css`font-size: 1.25rem;
    ${breakpoints.phone`
      font-size: 1.125rem;
    `}
  `,
  p: `font-size: 1rem;`,
  small: `font-size: 0.9rem`,
  light: css`
    font-weight: 400;
    ${breakpoints.retina`
      -webkit-font-smoothing: antialiased;
    `}
  `,
  normal: `font-weight: 500;`,
  bold: `
    font-weight: 700;
    -webkit-font-smoothing: antialiased;
  `,
  center: `text-align: center;`,
  right: `text-align: right;`,
  left: `text-align: left;`,
  white: `color: ${colors.offWhite};`,
  pink: `color: ${colors.pinkText};`,
  grey: `color: ${colors.greyText};`,
  blue: `color: ${colors.blueText};`,
  noDecoration: `text-decoration: none;`,
  underline: `text-decoration: underline;`,
  underlineOnHover: `&:hover { text-decoration: underline; }`,
  lh14: `line-height: 1.4;`,
  nowrap: `white-space: nowrap;`,
  uppercase: `text-transform: uppercase;`,
  inherit: `font-family: inherit;`
})

export const flex = wreck({
  default: `display: flex;`,
  inline: `display: inline-flex;`,
  vertical: `flex-direction: column;`,
  alignCenter: `align-items: center;`,
  alignStart: `align-items: flex-start;`,
  alignEnd: `align-items: flex-end;`,
  center: `justify-content: center;`,
  centerBoth: `justify-content: center; align-items: center;`,
  start: `justify-content: flex-start;`,
  end: `justify-content: flex-end;`,
  wrap: `flex-wrap: wrap;`
})

export const utils = {
  absFill: (padding = 0) => css`
    position: absolute;
    top: ${padding}rem;
    left: ${padding}rem;
    width: calc(100% - ${padding}rem);
    height: calc(100% - ${padding}rem);
  `,
  container: css`
    max-width: 40rem;
    margin: 0 auto;
  `
}

export const theme = {
  colorFg: props => `color: ${props.theme.fg};`,
  set: obj => props => props.updateTheme(obj)
}



/** WEBPACK FOOTER **
 ** ./src/styles.js
 **/